import * as React from 'react';
import NotFoundSvg from 'src/assets/icons/404.svg';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/system';
import Buttons from '../components/Buttons/Button';

interface Props {
  msg?: string;
  sub?: string;
  history: any;
  onGoBack?: any
}
const NotFound: React.FC<Props> = (props: Props) => {
 const { msg, sub, history, onGoBack } = props;
  const theme = useTheme();
  const goHome = () => {
    if (onGoBack){
      onGoBack();
    }
    history.goBack();
  };

  return (
    <Container>
      <Box width={400} margin="20px auto" alignItems="center">
        <NotFoundSvg color={theme.palette.primaryColor} />
      </Box>
      <Box display="flex" flexDirection="column" alignItems="center">
        <Typography variant="h4" mb={4}>
          {msg ? msg : 'Oops page not found'}{' '}
          <Typography component="span" variant="h4" color="primary">
            {sub}
          </Typography>
        </Typography>
        <Buttons px={20} text="Back to previous page" onClick={goHome} />
      </Box>
    </Container>
  );
}

export default compose(withRouter)(NotFound);
